import React from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { formatDate as fmtDateUtil } from '../../utils/dateUtils';
import { LoadingState, DonutChart, BarGraph, ReportTable, fmt } from './ReportHelpers';

const fmtDate = (d) => fmtDateUtil(d);

export function InvoicesTab({ data, loading, onExport }) {
  if (loading) return <LoadingState />;
  if (!data) return null;
  const handleExport = () => {
    const headers = ['Invoice No.', 'Date', 'Contact', 'Reference', 'Status', 'Subtotal', 'GST', 'Total'];
    const rows = data.items.map(r => [r.invoice_number, r.date, r.contact_name, r.reference, r.status, r.subtotal, r.gst, r.total]);
    const summary = ['', '', '', '', 'TOTAL', '', '', data.grand_total];
    onExport('Invoice Report', headers, rows, summary);
  };
  return (
    <div className="space-y-4" data-testid="invoices-tab">
      <div className="flex justify-end print:hidden">
        <button onClick={handleExport} className="flex items-center gap-1.5 px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700" data-testid="export-invoices-excel">
          <FileSpreadsheet size={14} /> Export Excel
        </button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <DonutChart data={data.by_status} title="Invoice Status Distribution" />
        <BarGraph data={data.by_status} title="Invoices by Status" />
      </div>
      <ReportTable
        headers={['Invoice No.', 'Date', 'Contact', 'Reference', 'Status', 'Subtotal', 'GST', 'Total']}
        rows={data.items.map(r => [r.invoice_number, fmtDate(r.date), r.contact_name, r.reference, r.status, fmt(r.subtotal), fmt(r.gst), fmt(r.total)])}
        footer={['', '', '', '', 'TOTAL', '', '', fmt(data.grand_total)]}
        testId="invoices-table"
      />
    </div>
  );
}
